import { ASTRO_DEVICE_MODEL, ASTRO_DEVICE_TYPE, BASE_STATION, INDOOR } from './constants';

function isBaseStation(device) {
  return device.type.includes(BASE_STATION);
}

export function isAstro(device) {
  return device.type === ASTRO_DEVICE_TYPE && device.thirdPartyModel === ASTRO_DEVICE_MODEL;
}

function isIndoor(device) {
  return device.starkDeviceDetails?.includes(INDOOR);
}

export function eligibleOutdoorDevicesFilter(devices) {
  return devices.filter((device) => device.starkEligible && !device.starkEligibleInfo && !isIndoor(device) && !isBaseStation(device));
}

export function eligibleIndoorDevicesFilter(devices) {
  return devices.filter((device) => device.starkEligible && isIndoor(device) && !isBaseStation(device));
}

export function notEligibleDevicesFilter(devices) {
  return devices.filter((device) => !device.starkEligible && !isBaseStation(device));
}

export function devicesWithoutBaseStationFilter(devices) {
  return devices.filter((device) => !isBaseStation(device));
}
